module.exports = __webpack_public_path__ + "static/9M_2025_Financial_Reporting_HSE_Investment_Sarl-3fa8f03ae25373e8e39aca4f9c792522.pdf";